export default {
  hotGame: [
    {
      id: 1,
      gameImage: 'http://8828game.com/webImages/image/01/game005.png',
      qrCode: 'http://8828game.com/webImages/image/01/qrgame01.jpg',
      gameName: '一起切水果',
      gameDesc: '现象级传播4000万用户，广告曝光超5亿次',
      hotGameActive: ''
    },
    {
      id: 2,
      gameImage: 'http://8828game.com/webImages/image/01/game02.jpg',
      qrCode: 'http://8828game.com/webImages/image/01/qrgame02.jpg',
      gameName: '我要养条狗',
      gameDesc: '购买合成收集类游戏，高峰期近40wDAU',
      hotGameActive: ''
    },
    {
      id: 3,
      gameImage: 'http://8828game.com/webImages/image/01/game03.jpg',
      qrCode: 'http://8828game.com/webImages/image/01/qrgame03.jpg',
      gameName: '最强消数字',
      gameDesc: '德州风格数字消除游戏，一旦入迷不可自拔',
      hotGameActive: ''
    },
    {
      id: 4,
      gameImage: 'http://8828game.com/webImages/image/01/game09.jpg',
      qrCode: 'http://8828game.com/webImages/image/01/qrgame04.jpg',
      gameName: '进击吧足球',
      gameDesc: '3D，模拟踢球游戏',
      hotGameActive: ''
    },
    {
      id: 5,
      gameImage: 'http://8828game.com/webImages/image/01/game006.png',
      qrCode: 'http://8828game.com/webImages/image/01/qrgame05.jpg',
      gameName: '疯狂怪兽车',
      gameDesc: '操控各种外形的赛车在跑道疾驰',
      hotGameActive: ''
    },
    {
      id: 6,
      gameImage: 'http://8828game.com/webImages/image/01/game06.jpg',
      qrCode: 'http://8828game.com/webImages/image/01/qrgame06.jpg',
      gameName: '盗猫笔记',
      gameDesc: '猫咪养成，互动游戏',
      hotGameActive: ''
    },
    {
      id: 7,
      gameImage: 'http://8828game.com/webImages/image/01/game07.jpg',
      qrCode: 'http://8828game.com/webImages/image/01/qrgame07.jpg',
      gameName: '怪兽连连线',
      gameDesc: '一笔画完益智游戏',
      hotGameActive: ''
    },
    {
      id: 8,
      gameImage: 'http://8828game.com/webImages/image/01/game10.jpg',
      qrCode: 'http://8828game.com/webImages/image/01/qrgame08.jpg',
      gameName: '猫咪大乱斗',
      gameDesc: '惊险刺激碰撞IO游戏',
      hotGameActive: ''
    }
  ],
  cooperationGame: [
    {
      id: 20,
      gameImage: 'http://8828game.com/webImages/image/01/pinpai20.jpg',
      qrCode: 'http://8828game.com/webImages/image/01/qrgame20.jpg',
      gameName: '《B Surf 冲浪小精灵》Burberry（博柏利）品牌合作',
      gameDesc: '《B Surf 冲浪小精灵》是和Burberry合作出品的一款3D类品牌推广小游戏，让Burberry首席卖萌官博博鹿带你体验夏日冲浪新玩法！',
      active: '',
      icon: 'http://8828game.com/webImages/image/01/icon20.jpg'
    },
    {
      id: 21,
      gameImage: 'http://8828game.com/webImages/image/01/pinpai21.jpg',
      qrCode: 'http://8828game.com/webImages/image/01/qrgame21.jpg',
      gameName: '《麦当劳游戏》麦当劳品牌传播合作',
      gameDesc: '《麦当劳游戏》是和麦当劳品牌合作基于品牌元素及套餐优惠券推出的各类营销小游戏，让你一边体验游戏快乐的同时还能获得各种优惠券！',
      active: '',
      icon: 'http://8828game.com/webImages/image/01/icon21.jpg'
    },
    {
      id: 4,
      gameImage: 'http://8828game.com/webImages/image/01/pinpai06.jpg',
      qrCode: 'http://8828game.com/webImages/image/01/qrgame09.png',
      gameName: '《坦克大战吃豆人小蜜蜂3合1》肯德基品牌传播合作',
      gameDesc: '《坦克大战吃豆人小蜜蜂3合1》是肯德基联合万代南梦宫娱乐知名ip由广州匠心出品的经典红白机小游戏，让你1秒穿越80、90年代的游戏时光，重温当年热血沸腾的游戏时光。经典IP引入，品牌发力、福利加持，这样的小游戏，有谁不爱！',
      active: '',
      icon: 'http://8828game.com/webImages/image/01/icon05.jpg'
    },
    {
      id: 6,
      gameImage: 'http://8828game.com/webImages/image/01/pinpai08.jpg',
      qrCode: 'http://8828game.com/webImages/image/01/qrgame11.jpg',
      gameName: '《蓝臻宝宝乐游游》美赞臣蓝臻品牌合作',
      gameDesc: '《蓝臻宝宝乐游游》是美赞臣蓝臻系列和广州匠心游戏合作出品的一款3D类品牌推广小游戏。宝宝健康活泼地成长是妈妈最大的心愿，多款不同风格的可爱宝宝让美赞臣妈妈们爱不释手，大大增加游戏代入感。',
      active: '',
      icon: 'http://8828game.com/webImages/image/01/icon07.jpg'
    },
    {
      id: 7,
      gameImage: 'http://8828game.com/webImages/image/01/pinpai10.jpg',
      qrCode: 'http://8828game.com/webImages/image/01/qrgame12.jpg',
      gameName: '《安儿宝开心牧场》美赞臣安儿宝品牌合作',
      gameDesc: '《安儿宝开心牧场》是和美赞臣蓝臻系列之后合作的第二款安儿宝品牌小游戏，通过简单有趣的割草操作感受可爱的牛牛自由放牧鲜草为食的过程，充分体现安儿宝的天然牧场五星草饲品牌理念。',
      active: '',
      icon: 'http://8828game.com/webImages/image/01/icon08.png'
    },
    {
      id: 8,
      gameImage: 'http://8828game.com/webImages/image/01/pinpai03.jpg',
      qrCode: 'http://8828game.com/webImages/image/01/qrcode03.jpg',
      gameName: '《直通天际》迪拜塔旅游商业合作',
      gameDesc: '人们对于高空、未知的探索总是欲望无穷，因此成就了迪拜塔（又名哈利法塔）和它相关的小游戏项目，游戏采用了迪拜塔的现代建筑风格用叠高楼的形式展现迪拜塔的高大雄伟。',
      active: '',
      icon: 'http://8828game.com/webImages/image/01/icon03.jpg'
    },
    {
      id: 5,
      gameImage: 'http://8828game.com/webImages/image/01/pinpai09.jpg',
      qrCode: 'http://8828game.com/webImages/image/01/qrgame10.jpg',
      gameName: '《钱袋子保卫战》央行金融知识传播合作',
      gameDesc: '《钱袋子保卫战》是中国人民银行和腾讯联合出品的金融知识普及小游戏。这款由广州匠心游戏研发的小游戏将金融知识融于游戏之中，将枯燥的科普信息变得生动有趣。',
      active: '',
      icon: 'http://8828game.com/webImages/image/01/icon06.jpg'
    },
    {
      id: 1,
      gameImage: 'http://8828game.com/webImages/image/01/pinpai01.jpg',
      qrCode: 'http://8828game.com/webImages/image/01/qrcode01.jpg',
      gameName: '《欢乐农场主》 财政部电商扶贫合作',
      gameDesc: '《欢乐农场主》是国家财政部、腾讯微信、广州匠心游戏联手致力于帮助国家贫困县宣传和农产品销售的公益项目，通过游戏的形式展现也是希望用更加愉快温暖的方式，让更多的人参与到行善互助中来。',
      active: '',
      icon: 'http://8828game.com/webImages/image/01/icon01.jpg'
    },
    {
      id: 2,
      gameImage: 'http://8828game.com/webImages/image/01/pinpai05.jpg',
      qrCode: 'http://8828game.com/webImages/image/01/qrcode04.jpg',
      gameName: '《超级飞侠冲冲冲》IP精品战略合作',
      gameDesc: '《超级飞侠》是一部全网点击百亿，多角色市场反响火爆的儿童动画，宣传以帮助别人为主基调非常正能量，我们希望小朋友能够通过游戏加深对每个飞侠的角色认知，从而提高IP认知度，并帮助品牌进行一定的周边销售。',
      active: '',
      icon: 'http://8828game.com/webImages/image/01/icon04.jpg'
    },
    {
      id: 3,
      gameImage: 'http://8828game.com/webImages/image/01/pinpai02.jpg',
      qrCode: 'http://8828game.com/webImages/image/01/qrcode02.jpg',
      gameName: '《萌鸡小队画画》 IP精品战略合作',
      gameDesc: '《萌鸡小队》动画有着70亿庞大的网络视频点击量，收罗了一群忠实的小粉丝；为做到寓教于乐的效果，特选IP+画画的游戏模式，自主创新角色舞蹈+音乐的玩法，大大增加了产品代入感，建立产品壁垒，让小朋友的天分更加自由的发挥',
      active: '',
      icon: 'http://8828game.com/webImages/image/01/icon02.jpg'
    }
  ],
  allGames: [
    {
      icon: 'http://8828game.com/webImages/image/01/gameicon01.png',
      gameName: '豆腐消消消'
    },
    {
      icon: 'http://8828game.com/webImages/image/01/gameicon02.jpg',
      gameName: '非常六合一'
    },
    {
      icon: 'http://8828game.com/webImages/image/01/gameicon03.jpg',
      gameName: '宇宙大冒险'
    },
    {
      icon: 'http://8828game.com/webImages/image/01/gameicon42.jpg',
      gameName: '坦克3合1'
    },
    {
      icon: 'http://8828game.com/webImages/image/01/gameicon05.png',
      gameName: '爆锤损友'
    },
    {
      icon: 'http://8828game.com/webImages/image/01/gameicon06.png',
      gameName: '最强消数字'
    },
    {
      icon: 'http://8828game.com/webImages/image/01/gameicon07.png',
      gameName: '答题大乱斗'
    },
    {
      icon: 'http://8828game.com/webImages/image/01/gameicon08.png',
      gameName: '最强弹力球'
    },
    {
      icon: 'http://8828game.com/webImages/image/01/gameicon09.jpg',
      gameName: '划线球球'
    },
    {
      icon: 'http://8828game.com/webImages/image/01/gameicon10.png',
      gameName: '最强预测'
    },
    {
      icon: 'http://8828game.com/webImages/image/01/gameicon11.png',
      gameName: '最强球爱'
    },
    {
      icon: 'http://8828game.com/webImages/image/01/gameicon12.jpg',
      gameName: '最强吃鸡王'
    },
    {
      icon: 'http://8828game.com/webImages/image/01/gameicon41.png',
      gameName: '全民投篮3D'
    },
    {
      icon: 'http://8828game.com/webImages/image/01/gameicon14.jpg',
      gameName: '最强嘴炮王'
    },
    {
      icon: 'http://8828game.com/webImages/image/01/gameicon15.jpg',
      gameName: '脑力大火拼'
    },
    {
      icon: 'http://8828game.com/webImages/image/01/gameicon16.png',
      gameName: '最强菊王'
    },
    {
      icon: 'http://8828game.com/webImages/image/01/gameicon17.png',
      gameName: '去吧皮卡叔'
    },
    {
      icon: 'http://8828game.com/webImages/image/01/gameicon18.png',
      gameName: '盗猫笔记'
    },
    {
      icon: 'http://8828game.com/webImages/image/01/gameicon19.png',
      gameName: '一起切水果'
    },
    {
      icon: 'http://8828game.com/webImages/image/01/gameicon20.png',
      gameName: '猫咪大乱斗'
    },
    {
      icon: 'http://8828game.com/webImages/image/01/gameicon21.png',
      gameName: '养猫达人'
    },
    {
      icon: 'http://8828game.com/webImages/image/01/gameicon22.png',
      gameName: '全民飞车3D'
    },
    {
      icon: 'http://8828game.com/webImages/image/01/gameicon23.png',
      gameName: '我要养条狗'
    },
    {
      icon: 'http://8828game.com/webImages/image/01/gameicon24.png',
      gameName: '怪兽连连线'
    },
    {
      icon: 'http://8828game.com/webImages/image/01/gameicon25.png',
      gameName: '进击吧足球'
    },
    {
      icon: 'http://8828game.com/webImages/image/01/gameicon26.png',
      gameName: '一起来切菜'
    },
    {
      icon: 'http://8828game.com/webImages/image/01/gameicon27.jpg',
      gameName: '水果大师'
    },
    {
      icon: 'http://8828game.com/webImages/image/01/gameicon28.jpg',
      gameName: '劲爆足球'
    },
    {
      icon: 'http://8828game.com/webImages/image/01/gameicon29.jpg',
      gameName: '王者俄罗斯方块'
    },
    {
      icon: 'http://8828game.com/webImages/image/01/gameicon30.jpg',
      gameName: '宝宝开餐厅'
    },
    {
      icon: 'http://8828game.com/webImages/image/01/gameicon31.jpg',
      gameName: '飞机大战3D'
    },
    {
      icon: 'http://8828game.com/webImages/image/01/gameicon32.png',
      gameName: '疯狂怪兽车'
    },
    {
      icon: 'http://8828game.com/webImages/image/01/gameicon33.png',
      gameName: '数字连连消'
    },
    {
      icon: 'http://8828game.com/webImages/image/01/gameicon34.png',
      gameName: '超级飞侠'
    },
    {
      icon: 'http://8828game.com/webImages/image/01/gameicon35.jpg',
      gameName: '萌鸡小队画画'
    },
    {
      icon: 'http://8828game.com/webImages/image/01/gameicon36.png',
      gameName: '一起切糖果'
    },
    {
      icon: 'http://8828game.com/webImages/image/01/gameicon37.jpg',
      gameName: '欢乐农场主'
    },
    {
      icon: 'http://8828game.com/webImages/image/01/gameicon38.jpg',
      gameName: '直通天际'
    },
    {
      icon: 'http://8828game.com/webImages/image/01/gameicon39.png',
      gameName: '本宫能活100集'
    },
    {
      icon: 'http://8828game.com/webImages/image/01/gameicon43.png',
      gameName: '塔塔军团'
    }
  ]
}
